export default "__VITE_ASSET__DfwtVLCN__"